<template>
  <v-text-field
    :value="value"
    :label="label"
    outlined
    v-bind="$attrs"
    v-on="$listeners"
    background-color="#fff"
    @input="(v) => $emit('input', v)"
    @change="updateMobileWithCode"
    @blur="updateMobileWithCode"
    :rules="mobileRules"
  ></v-text-field>
</template>

<script>
import { parsePhoneNumberFromString } from "libphonenumber-js";
export default {
  inheritAttrs: false,
  props: {
    value: { type: String },
    required: { type: Boolean, default: true },
    label: { type: String, default: "Mobile" },
  },
  computed: {
    mobileRules() {
      const rules = [];
      let rule = null;
      if (this.required) {
        rule = (v) => !!v || "Mobile number is required";
        rules.push(rule);
      }
      if (this.value) {
        rule = (v) =>
          (typeof v != "undefined" &&
            typeof parsePhoneNumberFromString(v || "", "AE") != "undefined" &&
            parsePhoneNumberFromString(v || "", "AE").isValid()) === true ||
          `Not a valid phone number`;
        rules.push(rule);
      }
      return rules;
    },
  },
  methods: {
    updateMobileWithCode() {
      let number = parsePhoneNumberFromString(this.value, "AE");
      if (number != null && number.isValid()) {
        this.$emit("input", number.number);
      }
    },
  },
};
</script>

<style>
</style>